import bemaTheme from './bema-theme'
import fxdTheme from './fxd-theme'

export const themes = {
  default: fxdTheme,
  bema: bemaTheme,
  fxd: fxdTheme
}
